// extracted by mini-css-extract-plugin
module.exports = {"logo":"style__logo___3Jtvl"};